import { render, staticRenderFns } from "./BadgeHeading.vue?vue&type=template&id=19ccbc3a"
import script from "./BadgeHeading.vue?vue&type=script&lang=js"
export * from "./BadgeHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports